export default __webpack_public_path__ + "static/media/paper-bonus.ecaa3306.png";